import { Flex } from '@qga/roo-ui/components';

import EmblaCarousel from '@shared/v2/components/EmblaCarousel';
import { isCurrentlyWithinDateRangeUTC } from '@shared/v2/utils/date';

import { useHomepageHero } from '@/v2/hooks/featureFlags/useHomepageHero';
import {
  PrimaryDefault,
  PrimaryPromo,
  SecondaryPromo,
} from '@/v2/services/sanity/types/api/response/homepageHero';
import PrimaryHero from '../PrimaryHero';
import SecondaryHero from '../SecondaryHero';

interface HeroProps {
  primaryPromo: PrimaryPromo;
  primaryDefault: PrimaryDefault;
  secondaryPromo: SecondaryPromo;
}

const MobileHero = ({
  primaryPromo,
  primaryDefault,
  secondaryPromo,
}: HeroProps) => {
  const { showPrimaryAndSecondary } = useHomepageHero();

  const isSecondaryPromoActive = isCurrentlyWithinDateRangeUTC(
    secondaryPromo.duration.start.utc,
    secondaryPromo.duration.end.utc,
  );

  if (!isSecondaryPromoActive || !showPrimaryAndSecondary) {
    return (
      <PrimaryHero
        key="primary-hero"
        primaryPromo={primaryPromo}
        primaryDefault={primaryDefault}
        isInCarousel={false}
        data-testid="HOMEPAGE_HERO_MOBILE"
      />
    );
  }

  const children = [
    <PrimaryHero
      key="primary-hero"
      primaryPromo={primaryPromo}
      primaryDefault={primaryDefault}
    />,
    <SecondaryHero key="secondary-hero" {...secondaryPromo} />,
  ];

  return (
    <Flex
      flexDirection="column"
      width="100%"
      data-testid="HOMEPAGE_HERO_MOBILE"
    >
      <Flex width="100%" height="100%" flexDirection="row" gap={0}>
        <EmblaCarousel>{children}</EmblaCarousel>
      </Flex>
    </Flex>
  );
};

export default MobileHero;
